import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}, null, -1)
const _hoisted_5 = { class: "ant-col" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 9,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_unidade = _resolveComponent("selecionar-unidade")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_buscar_itens_recebimento_mercadorias = _resolveComponent("buscar-itens-recebimento-mercadorias")!
  const _component_devolucao_compras_item_modal = _resolveComponent("devolucao-compras-item-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_tooltip, {
                  placement: "top",
                  name: "Selecionar itens do recebimento"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                      style: {"margin-top":"5px","margin-bottom":"5px"},
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selecionarItens && _ctx.selecionarItens(...args)))
                    }, " Inserir item ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_spin, {
          spinning: _ctx.state.carregandoItens
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              columns: _ctx.state.colunasGrade.filter(item => item.visible),
              "data-source": _ctx.props.itens,
              rowKey: "codigo",
              pagination: false,
              scroll: { y: 200 },
              size: "small",
              rowClassName: "ss-table-campos",
              bordered: ""
            }, {
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
              ]),
              bodyCell: _withCtx(({ column, record, index }) => [
                (column.key === 'acoes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("a", {
                        class: "visualizar",
                        onClick: ($event: any) => (_ctx.editarItem(index))
                      }, [
                        _createVNode(_component_icone, { nome: "editar" })
                      ], 8, _hoisted_9),
                      (_ctx.props.editavel)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "excluir",
                            onClick: ($event: any) => (_ctx.confirmarExclusao(index))
                          }, [
                            _createVNode(_component_icone, { nome: "excluir" })
                          ], 8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]))
                  : (column.key === 'Produto')
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "text",
                        class: "ant-input hidden",
                        value: record.itemNotaFiscal.descricao,
                        disabled: true
                      }, null, 8, _hoisted_11))
                    : (column.key === 'Unidade')
                      ? (_openBlock(), _createBlock(_component_selecionar_unidade, {
                          key: 2,
                          codigoSelecionado: record.itemNotaFiscal.codigoUnidade,
                          "apresentar-apenas-sigla": true,
                          title: record.itemNotaFiscal.descricaoUnidade,
                          disabled: true,
                          classCss: 'hidden ss-campo-selecao-table',
                          classGroupCss: "ss-campo-selecao-table"
                        }, null, 8, ["codigoSelecionado", "title"]))
                      : (column.key === 'Quantidade')
                        ? (_openBlock(), _createBlock(_component_campo_numerico, {
                            key: 3,
                            "quantidade-casas-decimais": 2,
                            valor: record.itemNotaFiscal.quantidade,
                            disabled: true,
                            classCss: "ss-campo-numero-table hidden",
                            classGroupCss: "hidden ss-campo-numero-table"
                          }, null, 8, ["valor"]))
                        : (column.key === 'ValorUnitario')
                          ? (_openBlock(), _createBlock(_component_campo_numerico, {
                              key: 4,
                              "quantidade-casas-decimais": 2,
                              monetario: true,
                              valor: record.itemNotaFiscal.precoUnitario,
                              disabled: true,
                              classCss: "ss-campo-numero-table hidden",
                              classGroupCss: "hidden ss-campo-numero-table"
                            }, null, 8, ["valor"]))
                          : (column.key === 'Icms')
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 5,
                                "quantidade-casas-decimais": 2,
                                percentual: true,
                                valor: record.itemNotaFiscal.impostos.icms.aliquotaIcms,
                                disabled: true,
                                classCss: "ss-campo-numero-table hidden",
                                classGroupCss: "hidden ss-campo-numero-table"
                              }, null, 8, ["valor"]))
                            : (column.key === 'Ipi')
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 6,
                                  "quantidade-casas-decimais": 2,
                                  percentual: true,
                                  valor: record.itemNotaFiscal.impostos.ipi.aliquotaIpi,
                                  disabled: true,
                                  classCss: "ss-campo-numero-table hidden",
                                  classGroupCss: "hidden ss-campo-numero-table"
                                }, null, 8, ["valor"]))
                              : (column.key === 'Desconto')
                                ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                    key: 7,
                                    "quantidade-casas-decimais": 2,
                                    monetario: true,
                                    valor: record.itemNotaFiscal.valorDesconto,
                                    disabled: true,
                                    classCss: "ss-campo-numero-table hidden",
                                    classGroupCss: "hidden ss-campo-numero-table"
                                  }, null, 8, ["valor"]))
                                : (column.key === 'Total')
                                  ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                      key: 8,
                                      "quantidade-casas-decimais": 2,
                                      monetario: true,
                                      valor: record.itemNotaFiscal.valorTotal,
                                      disabled: true,
                                      classCss: "ss-campo-numero-table hidden",
                                      classGroupCss: "hidden ss-campo-numero-table"
                                    }, null, 8, ["valor"]))
                                  : (column.key === 'Item')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("span", null, [
                                          _createElementVNode("a", {
                                            onClick: ($event: any) => (_ctx.editarItem(index))
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(record.itemNotaFiscal.descricao), 1)
                                          ], 8, _hoisted_13)
                                        ]),
                                        _createElementVNode("span", null, "Quantidade: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.quantidade, 2)) + "(" + _toDisplayString(record.itemNotaFiscal.descricaoUnidade) + ") ", 1),
                                        _createElementVNode("span", null, "Vlr Unitário: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.precoUnitario, 2, true)), 1),
                                        _createElementVNode("span", null, "Desconto: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.valorDesconto, 2, true)), 1),
                                        _createElementVNode("span", null, "Total: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.valorTotal, 2, true)), 1),
                                        _createElementVNode("div", _hoisted_14, [
                                          _createElementVNode("a", {
                                            class: "visualizar",
                                            onClick: ($event: any) => (_ctx.editarItem(index))
                                          }, [
                                            _createVNode(_component_icone, { nome: "editar" })
                                          ], 8, _hoisted_15),
                                          (_ctx.props.editavel)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "excluir",
                                                onClick: ($event: any) => (_ctx.confirmarExclusao(index))
                                              }, [
                                                _createVNode(_component_icone, { nome: "excluir" })
                                              ], 8, _hoisted_16))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source"])
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ]),
    _createVNode(_component_buscar_itens_recebimento_mercadorias, {
      visivel: _ctx.state.exibirBuscarItem,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirBuscarItem) = $event)),
      empresa: _ctx.props.empresa,
      pessoa: _ctx.props.pessoa,
      filtros: _ctx.state.filtrosRecebimentos,
      ignorarDevolvidos: true,
      codigoFornecedor: _ctx.props.codigoFornecedor,
      onConfirmacao: _ctx.adicionarItens
    }, null, 8, ["visivel", "empresa", "pessoa", "filtros", "codigoFornecedor", "onConfirmacao"]),
    _createVNode(_component_devolucao_compras_item_modal, {
      estoquesDisponiveis: _ctx.props.estoquesDisponiveis,
      empresa: _ctx.props.empresa,
      pessoa: _ctx.props.pessoa,
      totalNota: _ctx.props.totalNota,
      item: _ctx.state.itemSelecionado,
      existeAnterior: _ctx.state.existeAnterior,
      existeProximo: _ctx.state.existeProximo,
      visivel: _ctx.state.exibirDetalhesItem,
      "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.exibirDetalhesItem) = $event)),
      editavel: _ctx.props.editavel,
      onSalvar: _ctx.salvarItem,
      onProximoItem: _ctx.proximoItem,
      onItemAnterior: _ctx.itemAnterior
    }, null, 8, ["estoquesDisponiveis", "empresa", "pessoa", "totalNota", "item", "existeAnterior", "existeProximo", "visivel", "editavel", "onSalvar", "onProximoItem", "onItemAnterior"])
  ]))
}